// Reset-password route (public): the emailed link carries the token in the #token= fragment, which the screen reads and strips.
import { createFileRoute } from "@tanstack/react-router";

import { ResetPasswordPage } from "@/features/auth/ResetPasswordPage";

export const Route = createFileRoute("/reset-password")({
  component: ResetPasswordPage,
});
